import React from 'react';
import { Form } from 'react-bootstrap';
import styles from './oneWayInterviewConfiguration.module.scss';
import { CustomTextField } from '../../../../../shared/customTextField';
import { CustomButton } from '../../../../../shared/customButton';
import * as yup from 'yup';
import { Formik } from 'formik';
import { CustomDropdown } from '../../../../../shared/customDropdown';

const OneWayInterviewConfiguration = (props) => {
    // Yup validations
    const schema = yup.object({
        interview_name: yup.string()
            .trim()
            .matches(/^[^<>=*$^]*$/, 'Remove restricted characters such as: < > = $ * ^')
            .max(60, 'Character length should be less than 60')
            .required('Required'),
        max_attempts_per_ques: yup.number()
            .required('Required')
    });

    // On submit function
    const onSubmit = async (values) => {
        props.setOneWayInterviewConfiguration(values);
        props.nextPage(2);
    };

    const maxAttemptsPerQues = [
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
    ];

    return (
        <div>
            <Formik
                validationSchema={schema}
                onSubmit={onSubmit}
                initialValues={{
                    interview_name: props.oneWayInterview.interview_name,
                    max_attempts_per_ques: props.oneWayInterview.max_attempts_per_ques || 1
                }}
            >
                {({
                    values,
                    errors,
                    handleChange,
                    handleSubmit,
                    setFieldValue,
                    submitCount
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <CustomTextField
                            label="Template Name"
                            labelToolTip="This is only for internal recruiting team’s reference"
                            labelToolTipId="onewayInterviewTemplateName"
                            classLabel="defaultLabel"
                            controlId="adminPanel_evalauationTemplate_oneWayInterviewTemplates_createOneWayInterviewModal_oneWayInterviewConfiguration_templateNameFieldId"
                            placeholder="Ex: Software Engineers Template"
                            type="text"
                            value={values.interview_name}
                            name="interview_name"
                            classType="defaultTextBox"
                            handleOnChange={handleChange}
                            maxlength={60}
                            errorMessage={errors.interview_name}
                            validationMessageId="adminPanel_evalauationTemplate_oneWayInterviewTemplates_createOneWayInterviewModal_oneWayInterviewConfiguration_templateNameValidationMsgId"
                            isInvalid={submitCount > 0 && !!errors.interview_name}
                        />
                        <CustomDropdown
                            label="Max attempts per question"
                            labelToolTip="How many times a candidate can rerecord their answers per question"
                            labelToolTipId="maxAttemptsPerQues"
                            controlId="adminPanel_evalauationTemplate_oneWayInterviewTemplates_createOneWayInterviewModal_oneWayInterviewConfiguration_maxAttemptsPerQuestionFieldId"
                            name="max_attempts_per_ques"
                            value={values.max_attempts_per_ques}
                            handleOnChange={(e) => {
                                setFieldValue('max_attempts_per_ques', parseInt(e.target.value));
                            }}
                            dropdownValues={maxAttemptsPerQues}
                            errorMessage={errors.max_attempts_per_ques}
                            validationMessageId="adminPanel_evalauationTemplate_oneWayInterviewTemplates_createOneWayInterviewModal_oneWayInterviewConfiguration_maxAttemptsPerQuestionFieldValidationMsgId"
                            isInvalid={submitCount > 0 && !!errors.max_attempts_per_ques}
                        />
                        <hr className={styles.dividerLine} />
                        <div className='d-flex flex-row-reverse'>
                            <div className={styles.navigateBtnCol}>
                                <CustomButton
                                    id="adminPanel_evalauationTemplate_oneWayInterviewTemplates_createOneWayInterviewModal_oneWayInterviewConfiguration_reviewBtnId"
                                    buttonType="submit"
                                    label="Review"
                                    type="primaryBtn"
                                />
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
}

export default OneWayInterviewConfiguration;
